<template>
  <div class="mx-auto flex flex-row bg-white">
    <section slot="pdf-content" class="w-full">
      <div
        class="flex w-full flex-col items-center bg-white pl-6 pr-12"
        style="font-weight: 600; font-family: 'Courier New', Courier, monospace !important;"
      >
        <!-- Header -->
        <!-- kiri -->
        <div class="w-full text-left">
          <h1 class="text-md">PT. NATURAL NUSANTARA</h1>
        </div>
        <div class="grid w-full grid-cols-2 gap-y-6">
          <div class="flex max-w-xs flex-col">
            <address class="text-xs">
              Jl. Ring Road Barat No. 72 Salakan Trihanggo Gamping Sleman
              Jogjakarta 55291
            </address>
            <p class="text-xs">Telp:0274-6499191</p>
          </div>
          <div v-if="originOffice" class="flex max-w-xs flex-col">
            <p
              v-if="originOffice.attributes.office_type"
              class="text-xs capitalize"
            >
              {{ originOffice.attributes.office_type.split('_').join(' ') }} ({{
                originOffice.attributes.code
              }})
            </p>
            <p
              class="text-xs"
              v-if="originOffice.attributes.address_details?.length"
            >
              {{ originOffice.attributes.address_details[0].city }}
            </p>
            <address v-if="originOffice?.attributes.address" class="text-xs">
              {{ originOffice.attributes.address }}
            </address>
            <p class="text-xs">
              Telp: {{ originOffice.attributes.kta ?? '-' }}
            </p>
          </div>
        </div>

        <!-- Bill to -->
        <div class="mt-2 grid w-full grid-cols-2 justify-between">
          <div class="flex w-full flex-col" v-if="order.data">
            <h1 class="text-sm font-extrabold">Kepada:</h1>
            <p class="text-xs italic" v-if="order?.data.relationships">
              Bpk/Ibu
              <span class="font-bold text-base">{{
                getRelationships(
                  order,
                  order.data.relationships['destination-office'].data?.id
                )?.attributes.name ?? '-'
              }}</span> 
              <span>, </span>
              <span class="font-bold text-base">{{
                getRelationships(
                  order,
                  order.data.relationships['destination-office'].data?.id
                )?.attributes.code + ','
              }}</span>
              <span>
                <address>
                  {{ order.data.attributes.receipt_name || (destinationOffice?.attributes?.name ?? '-') }},
                  {{ order.data.attributes.receipt_phone || (destinationOffice?.attributes?.phone ?? '-') }},
                  {{ order.data.attributes.complete_shipment_address }}
                </address>
              </span>
            </p>
          </div>
          <!-- kanan -->
          <div class="flex flex-col md:flex-shrink">
            <div class="flex flex-row items-center gap-x-1 text-xs">
              <p class="w-24 font-extrabold text-black">No.Invoice</p>
              <p>:</p>
              <p class="flex-grow flex-shrink-0 font-bold text-base">
                {{ order.data.attributes.origin_code }} /
                {{ order.data.attributes.reference_code }}
              </p>
            </div>
            <div class="flex flex-row items-center gap-x-1 text-xs">
              <p class="w-24 font-extrabold text-black">Tgl Invoice</p>
              <p>:</p>
              <p class="w-32 flex-shrink-0 font-bold">
                {{
                  dayjs(order.data.attributes.updatedAt).format('DD/MM/YYYY')
                }}
              </p>
            </div>
            <div class="flex flex-row items-center gap-x-1 text-xs">
              <p class="w-24 font-extrabold text-black">Waktu</p>
              <p>:</p>
              <p class="w-32 flex-shrink-0 font-bold">
                {{ dayjs(order.data.attributes.updatedAt).format('LT') }}
              </p>
            </div>
            <div class="flex flex-row items-center gap-x-1 text-xs">
              <p class="w-24 font-extrabold text-black">Wilayah</p>
              <p>:</p>
              <p class="w-32 flex-shrink-0 font-bold">
                {{ order.data.attributes.area_name }} ({{
                  order.data.attributes.area_code
                }})
              </p>
            </div>
          </div>
        </div>

        <p class="font-bold">SURAT PERINTAH PENGELUARAN BARANG</p>

        <!-- Barang Point -->
        <div
          v-for="(items, itemsIndex) in stockSummary"
          :key="items.label"
          class="mt-3 flex w-full justify-between gap-x-6"
        >
          <div v-if="items.value.length > 0" class="flex w-full flex-col">
            <h1 class="text-sm uppercase">{{ items.label }}</h1>
            <div v-for="(data, dataIndex) in items.value" :key="dataIndex">
              <table class="text-xs w-full">
                <thead>
                  <tr>
                    <td class="py-2" style="width: 25%;">Kode</td>
                    <td class="py-2" style="width: 25%;">Nama Barang</td>
                    <td class="py-2" style="width: 12.5%;">Jumlah</td>
                    <td class="py-2" style="width: 12.5%;">Total BV</td>
                    <td class="py-2" style="width: 12.5%;">Harga Stc</td>
                    <td class="py-2" style="width: 12.5%;">Total Harga</td>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="text-xs"
                    v-for="(stock, index) in data"
                    :key="index"
                    style="
                      line-height: 0.5rem;
                      border-top: 1px dashed black;
                      border-bottom: 1px dashed black;
                    "
                  >
                    <td class="relative bottom-2 py-2">
                      <span class="font-bold text-base">
                        {{ stock.attributes.product_code }}

                        <template v-if="stock.type === 'order-detail-bonuses'">
                          (FREE)
                        </template>
                      </span>
                    </td>
                    <td class="relative bottom-2 py-2">
                      {{ stock.attributes.product_name }}
                    </td>
                    <td class="relative bottom-2 py-2">
                      <span v-if="stock.type === 'order-details'" class="font-bold text-base">{{ (stock.attributes.product_qty - stock.attributes.product_shipped_qty) | toCurrency }}</span>
                      <span v-else class="font-bold text-base">{{ (stock.attributes.bonus_not_packed_qty) | toCurrency }}</span>
                    </td>
                    <td class="relative bottom-2 py-2">
                      <span v-if="stock.type === 'order-details'">{{ parseInt(stock.attributes.bonus_value) | toCurrency }}</span>
                    </td>
                    <td class="relative bottom-2 py-2">
                      {{ stock.attributes.product_price | toCurrency }}
                    </td>
                    <td class="relative bottom-2 py-2">
                      {{ stock.attributes.total_price | toCurrency }}
                    </td>
                  </tr>
                </tbody>
              </table>

              <template v-if="dataIndex < (items.value.length - 1) && data.length >= (dataIndex === 0 ? (itemsIndex === 0 ? firstPageChunk : lastItemStartChunk) : perPageChunk)">
                <div class="html2pdf__page-break"></div>
                <div class="w-full text-right">{{ getCurrentPage() }}</div>
              </template>
            </div>
            <table>
              <tbody>
                <tr>
                  <td colspan="3" class="py-2" style="width: 62.5%"></td>
                  <td class="text-xs font-extrabold" style="width: 12.5%;">
                    {{ getSubBonusValue(items.value) | toCurrency }}
                  </td>
                  <td class="font-base text-xs" style="width: 12.5%;">Sub Total</td>
                  <td class="text-xs font-extrabold" style="width: 12.5%;">
                    {{ getGrandTotalPrice(items.value) | toCurrency }}
                  </td>
                </tr>
              </tbody>
            </table>

            <template v-if="itemsIndex === 0 && lastItemNewPage">
              <div class="html2pdf__page-break"></div>
              <div class="w-full text-right">{{ getCurrentPage() }}</div>
            </template>
          </div>
        </div>

        <template v-if="summaryNewPage">
          <div class="html2pdf__page-break"></div>
          <div class="w-full text-right">{{ getCurrentPage() }}</div>
        </template>

        <!-- Footer -->
        <div class="mt-4 flex w-full flex-col justify-between">
          <footer class="flex w-full flex-col items-end justify-end">
            <div
              style="border-top: 1px dashed black"
              class="w-full border-gray-700"
            >
              <div class="flex justify-end">
                <div
                  class="flex flex-row gap-x-2"
                  style="border-bottom: 1px dashed black"
                >
                  <div class="relative bottom-2 sm:col-span-1">
                    <label for="invoice" class="font-base block text-base">
                      Total Pembelian
                    </label>
                  </div>
                  <div class="relative bottom-2 sm:col-span-1">
                    <label for="invoice" class="block text-base font-extrabold">
                      {{ getGrandTotalPrice(order_details) | toCurrency }}
                    </label>
                  </div>
                </div>
              </div>
              <!-- dasar pengenaan pajak -->
              <div class="flex justify-end">
                <div class="flex flex-row gap-x-2">
                  <div class="sm:col-span-1">
                    <label for="invoice" class="font-base block text-xs">
                      Dasar Pengenaan Pajak
                    </label>
                  </div>
                  <div class="sm:col-span-1">
                    <label for="invoice" class="block text-xs font-extrabold">
                      {{ dpp | toCurrency }}
                    </label>
                  </div>
                </div>
              </div>
              <!-- ppn -->
              <div class="flex justify-end">
                <div class="flex flex-row gap-x-2">
                  <div class="sm:col-span-1">
                    <label for="invoice" class="font-base block text-xs">
                      PPN 11%
                    </label>
                  </div>
                  <div class="sm:col-span-1">
                    <label for="invoice" class="block text-xs font-extrabold">
                      {{ ppn | toCurrency }}
                    </label>
                  </div>
                </div>
              </div>

              <div class="flex flex-col pt-4">
                <div class="flex flex-row justify-between gap-x-2">
                  <div class="sm:col-span-1">
                    <label for="invoice" class="font-base block text-xs">
                      Catatan: {{ order.data.attributes.notes ?? '-' }}
                    </label>
                  </div>
                </div>
                <div class="flex flex-row justify-between gap-x-2">
                  <div class="sm:col-span-1">
                    <label for="invoice" class="font-base block text-xs">
                      Metode Pengiriman: {{ order.data.attributes.order_shipment === 'pickup' ? 'Diambil' : 'Dikirim' }}
                    </label>
                  </div>
                </div>
                <div class="flex flex-row justify-between gap-x-2">
                  <div class="sm:col-span-1">
                    <label for="invoice" class="font-base block text-xs">
                      Tanggal & Jam Cetak:
                      {{ dayjs().format('DD/MM/YY HH:mm') }}
                    </label>
                  </div>
                </div>
                <div class="flex flex-row justify-between gap-x-2">
                  <div class="sm:col-span-1">
                    <label for="invoice" class="font-base block text-xs">
                      Dicetak {{ order.data.attributes.sppb_print_count }}x
                    </label>
                  </div>
                </div>
                <div class="flex flex-row justify-between gap-x-2">
                  <div class="sm:col-span-1">
                    <label for="invoice" class="font-base block text-xs">
                      Dicetak oleh : {{ me.name }}
                    </label>
                  </div>
                </div>
                <div class="flex flex-row justify-between gap-x-2">
                  <div class="sm:col-span-1">
                    <label for="invoice" class="font-base block text-xs">
                      Barang disiapkan oleh :
                    </label>
                  </div>
                </div>
                <div v-if="label" class="flex flex-row justify-between gap-x-2">
                  <div class="sm:col-span-1">
                    <label for="invoice" class="font-base block text-xs">
                      Jenis Pengeluaran : {{ label }}
                    </label>
                  </div>
                </div>
              </div>

              <div class="my-6 flex w-full justify-end">
                <div
                  class="mt-3 border-t-2 border-dashed border-gray-700 sm:col-span-1"
                >
                  <label for="invoice" class="block text-xs font-extrabold">
                    {{ getBagian() }}
                  </label>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';

export default {
  components: {},

  props: {
    order: {
      type: Object,
      default: () => ({
        id: '',
        attributes: {},
      }),
    },
    withOriginAddress: {
      type: Boolean,
      default: false,
    },
    label: String
  },

  data() {
    return {
      dataPenjualan: {},
      firstPageChunk: 20,
      perPageChunk: 25,
    };
  },
  computed: {
    ...mapGetters({
      getLoading: 'orders/getLoading',
      me: 'auth/getUser'
    }),
    originOffice() {
      return this.order.included.find((it) => {
        return (
          it.id == this.order?.data.relationships['origin-office']?.data.id
        );
      });
    },
    destinationOffice() {
      return this.order.included.find((it) => {
        return (
          it.id == this.order?.data.relationships['destination-office']?.data.id
        );
      });
    },
    order_details() {
      return this.order.data.relationships?.['order-details']?.data?.map((it) =>
        this.getRelationships(this.order, it.id)
      );
    },
    pointCount() {
      return this.order.included.filter(include => include.attributes.is_point && (include.type == 'order-details' || include.type == 'order-detail-bonuses')).length
    },
    nonPointCount() {
      return this.order.included.filter(include => !include.attributes.is_point && (include.type == 'order-details' || include.type == 'order-detail-bonuses')).length
    },
    summaryNewPage() {
      if (this.nonPointCount < 1) {
        if (this.pointCount < 15) {
          return false
        }

        const excludeFirstPagePointCount = this.pointCount - this.firstPageChunk

        if (excludeFirstPagePointCount < 15) {
          return false
        }

        if ((excludeFirstPagePointCount % this.perPageChunk) < 20) {
          return false
        }

        return true
      }

      if (this.lastItemNewPage) {
        return this.nonPointCount % this.perPageChunk > 15
      }

      if (this.lastItemStartChunk - 5 < (this.lastItemStartChunk < 10 ? 5 : 10) && this.nonPointCount < this.lastItemStartChunk) {
        return true
      }

      const excludeFirstPageNonPointCount = this.nonPointCount - this.lastItemStartChunk

      if (excludeFirstPageNonPointCount < 20) {
        return false
      }

      if (excludeFirstPageNonPointCount < this.perPageChunk) {
        return true
      }

      if (excludeFirstPageNonPointCount % this.perPageChunk < 20) {
        return false
      }

      return true
    },
    lastItemNewPage() {
      if (this.pointCount < this.firstPageChunk) {
        return false
      }

      const excludeFirstPagePointCount = this.pointCount - this.firstPageChunk

      return excludeFirstPagePointCount % this.perPageChunk === 0
    },
    lastItemStartChunk() {
      if (this.lastItemNewPage) {
        return false
      }

      if (this.pointCount < this.firstPageChunk) {
        return this.firstPageChunk - (this.pointCount + 2)
      }

      const excludeFirstPagePointCount = this.pointCount - this.firstPageChunk

      return this.perPageChunk - ((excludeFirstPagePointCount % this.perPageChunk) + 2)
    },
    barangPoint() {
      const data = this.order.included
        ?.filter(
          (it) => it.attributes.is_point && (it.type == 'order-details' || it.type == 'order-detail-bonuses')
        )
        .filter(item => {
          if (item.type === 'order-detail-bonuses') {
            return true
          }

          return item.attributes.product_shipped_qty < item.attributes.product_qty
        })

      return this.chunk(data, this.perPageChunk, this.firstPageChunk)
    },
    barangNonPoint() {
      const data = this.order.included
        ?.filter(
          (it) => !it.attributes.is_point && (it.type == 'order-details' || it.type == 'order-detail-bonuses')
        )
        .filter(item => {
          if (item.type === 'order-detail-bonuses') {
            return true
          }

          return item.attributes.product_shipped_qty < item.attributes.product_qty
        })
      
      return this.chunk(data, this.perPageChunk, this.lastItemStartChunk)
    },
    stockSummary() {
      return [
        {
          label: 'Barang Berpoint',
          value: this.barangPoint,
        },
        {
          label: 'Barang Non Point',
          value: this.barangNonPoint,
        },
      ];
    },
    dpp() {
      return this.getGrandTotalPrice(this.order_details) * (100 / 111);
    },
    ppn() {
      return this.dpp * (11 / 100);
    },
  },
  methods: {
    dayjs,
    getCurrentPage() {
      const currentPage = localStorage.getItem('print_sppb_page')
        ? +localStorage.getItem('print_sppb_page')
        : 0

      localStorage.setItem('print_sppb_page', currentPage + 1)

      return `${this.order.data.attributes.origin_code} / ${this.order.data.attributes.reference_code} / ${currentPage + 1}`
    },
    chunk(arr, size, sizeFirstPage = false) {
      if (sizeFirstPage) {
        const firstPage = arr.slice(0, sizeFirstPage)

        return [
          firstPage,
          ...this.chunk(arr.slice(sizeFirstPage), size)
        ]
      }

      return Array.from({ length: Math.ceil(arr.length / size) }, (_, i) => {
        const offset = i * size

        return arr.slice(offset, offset + size)
      })
    },
    getSubBonusValue(value) {
      return value?.flat().reduce(function (total, current) {
        if (current.type === 'order-detail-bonuses') {
          return total
        }

        return total + (parseInt(current.attributes.bonus_value) ?? 0);
      }, 0);
    },
    getBagian() {
      const router = this.$router;
      if (router.currentRoute.path.includes('penjualan')) {
        return 'Bag. Penjualan';
      } else if (router.currentRoute.path.includes('gudang')) {
        return 'Bag. Gudang';
      } else if (router.currentRoute.path.includes('kasir')) {
        return 'Bag. Kasir';
      }
      return '';
    },
    getGrandTotalPrice(value) {
      return value?.flat().reduce(function (total, current) {
        return total + (current.attributes.total_price ?? 0);
      }, 0);
    },
    getGrandTotalWeight(value) {
      return value?.reduce(function (total, current) {
        return total + parseFloat(current.total_weight);
      }, 0);
    },
    getGrandTotalBV(value) {
      return value?.reduce(function (total, current) {
        return total + ((current.bonus_value || 0) * current.product_qty || 0);
      }, 0);
    },
    getRelationships(resource, id) {
      let data = resource.included?.find(function (el) {
        return el.id === id;
      });
      return data;
    },
  },
};
</script>
